import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StressAreaComponent } from '../stress-area/stress-area.component';


@Component({
  selector: 'app-dialog-stress-area',
  templateUrl: './dialog-stress-area.component.html',
  styleUrls: ['./dialog-stress-area.component.css'],
  template: 'passed in {{ data.id, data.button }}'
})
export class DialogStressAreaComponent {
  
    
  constructor(
    private  dialogRef:  MatDialogRef<StressAreaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: string, buttonCancel: string }) { }
}
